<template>
    <div>
        <vx-card class="my-4">
            <div class="vx-row">
                <div class="vx-col w-full mb-4 sm:w-1/4 sm:mb-0">
                    <v-select label="name" placeholder="Site" class="w-full" v-model="site" :options="siteLists"></v-select>
                </div>
                <div class="vx-col w-full mb-4 flex-grow flex justify-end sm:w-3/4 sm:mb-0">
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"
                        @click.prevent="addNewCustomReport">Tambah</vs-button>
                </div>
            </div>
        </vx-card>
        <vx-card>
            <vs-table stripe :data="lists" search>
                <template slot="thead">
                    <vs-th>No</vs-th>
                    <vs-th class="text-left">Report Name</vs-th>
                    <vs-th class="text-left">Event</vs-th>
                    <vs-th class="text-right">&nbsp;</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="indextr">
                            {{ indextr + 1 }}
                        </vs-td>

                        <vs-td class="text-left" :data="tr.name">
                            {{ tr.reportName }}
                        </vs-td>

                        <vs-td class="text-left" :data="tr.event">
                            {{ tr.parameterEventName }}
                        </vs-td>

                        <vs-td class="text-right">
                            <div class="flex justify-end">
                                <vs-tooltip text="Delete">
                                    <a class="mr-2" href="javascript:void(0)" @click.prevent="deleteReport(tr.id)">
                                        <feather-icon icon="TrashIcon" svgClasses="icon" />
                                    </a>
                                </vs-tooltip>
                                <vs-tooltip text="Edit">
                                    <a class="mr-2" @click.prevent="editCustomReport(tr)">
                                        <feather-icon icon="EditIcon" svgClasses="icon" />
                                    </a>
                                </vs-tooltip>
                                <vs-tooltip text="Detail">
                                    <!-- <router-link :to="`/alarm/${tr.id}`"> -->
                                    <a href="" @click.prevent="openDetailCustomReport(tr)">
                                        <feather-icon icon="ChevronRightIcon" svgClasses="icon" />
                                    </a>
                                </vs-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import DatePicker from 'vue2-datepicker';
import api from "@/api";
import dummyData from "./dummy_custom_report.json";

import 'vue2-datepicker/index.css';

export default {
    data() {
        return {
            disabledDates: {
                from: new Date()
            },
            daterange: '',
            site: null,
            siteLists: [],
            lists: [],
            searchQuery: "",
        }
    },
    computed: {
        dummyData() {
            return dummyData
        }
    },
    watch: {
        site(newVal, oldVal) {
            if (newVal != null && oldVal != newVal) {
                const reportSearch = localStorage.getItem('reportSearch')
                const reportSearchParsed = JSON.parse(reportSearch)
                if(reportSearchParsed != undefined && reportSearchParsed != null && reportSearchParsed != '') {
                    reportSearchParsed.site = newVal
                    localStorage.setItem('reportSearch', JSON.stringify(reportSearchParsed))
                } else {
                    localStorage.setItem('reportSearch', JSON.stringify({
                        site: newVal
                    }))
                }
                this.getLists()
            }
        }
    },
    components: {
        DatePicker,
        vSelect
    },
    beforeMount() {
        const reportSearch = localStorage.getItem('reportSearch')
        const reportSearchParsed = JSON.parse(reportSearch)
        if(reportSearchParsed != undefined && reportSearchParsed != null && reportSearchParsed != '') {
            this.site = reportSearchParsed.site
        }
    },
    mounted() {
        this.getSiteLists()
    },
    methods: {
        openDetailCustomReport(row) {
            localStorage.setItem('selectedCustomReport', JSON.stringify(row))
            this.$router.push(`/custom_report/${row.id}`)
        },  
        // deleteReport(id) {
        //     this.$vs.loading()
        //     api.deleteCustomReport(id)
        //     .then(result => result.data)
        //             .then(data => {
        //                 console.log(data)
        //                 this.$vs.loading.close()
        //             })
        //             .catch((e) => {
        //                 console.log(e)
        //                 this.$vs.loading.close()
        //             });
        // },
        deleteReport(id) {
                this.$vs.loading();
                api.deleteCustomReport(id)
                .then(result => result.data)
                .then(data => {
                console.log(data);
                this.$vs.notify({
                title:'Success',
                text:'Delete data success',
                color:'success',
                position:'top-right'
            })
                this.$vs.loading.close();
            })
            .finally(() => {
            this.getLists()
            })
            .catch((e) => {
            console.log(e);
            this.$vs.notify({
            title:'Failed',
            text:'Delete data failed',
            color:'danger',
            position:'top-right'
            })
            this.$vs.loading.close();
            });
        },
        addNewCustomReport() {
            this.$router.push('/custom_report/add')
        },
        getSiteLists() {
            if (this.$store.state.sites.length > 0) {
                this.siteLists = this.$store.state.sites
            } else {
                this.$vs.loading()
                api.sites({
                    siteName: this.searchQuery
                })
                    .then(result => result.data)
                    .then(data => {
                        if (data.status) {
                            this.siteLists = data.data
                            this.$store.dispatch('updateSiteLists', data.data)
                        }
                        this.$vs.loading.close()
                    })
                    .catch((e) => {
                        console.log(e)
                        this.$vs.loading.close()
                    });
            }
        },
        getLists() {
            this.$vs.loading()
            api.getCustomReportLists({
                siteId: this.site.id
            })
                .then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.lists = data.data
                    }
                    this.$vs.loading.close()
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        editCustomReport(item) {
            localStorage.setItem('selectedCustomReport', JSON.stringify(item))
            this.$router.push(`/custom_report/${item.id}/edit`)
        }
    }
}
</script>